import {List} from 'immutable'
import PropTypes from 'prop-types'

import FuneralPackageDetail from './FuneralPackageDetail'

import './funeralPackageGroup.scss'

const FuneralPackageGroup = ({icon, items = List(), label, subLabel}) => {
  if (!items || items.isEmpty()) return null

  return (
    <div className='funeral-package-group' data-testid='funeral-package-group'>
      <div className='group-header'>
        <div className='group-icon'><img alt='' src={icon} /></div>
        <div className='group-label'>{label}</div>
        {subLabel && <div className='group-sub-label'>{subLabel}</div>}
      </div>
      <div className='group-items'>
        {
          items.map((item, index) => (
            <FuneralPackageDetail
              detail={item}
              key={item.get('id') || `${label}-${index}`}
            />
          ))
        }
      </div>
    </div>
  )
}

FuneralPackageGroup.propTypes = {
  icon: PropTypes.string,
  items: PropTypes.instanceOf(List),
  label: PropTypes.string,
  subLabel: PropTypes.string
}

export default FuneralPackageGroup
